import React from "react";
import { Stack, Switch, Chip } from "@mui/material";

/** value: boolean ou "active" | "inactive" (backend). onChange recebe boolean. */
const AgentStatusToggle = ({ value = false, onChange, size = "small", disabled = false }) => {
  const isActive = value === "active" || value === true;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Switch
        size={size}
        checked={isActive}
        onChange={(e) => onChange?.(e.target.checked)}
        disabled={disabled}
      />
      <Chip
        size={size}
        label={isActive ? "Ativo" : "Inativo"}
        color={isActive ? "success" : "default"}
        variant="outlined"
      />
    </Stack>
  );
};

export default AgentStatusToggle;

